import { render, staticRenderFns } from "./DragDropTable.vue?vue&type=template&id=7f0f0c76&scoped=true&"
import script from "./DragDropTable.vue?vue&type=script&lang=js&"
export * from "./DragDropTable.vue?vue&type=script&lang=js&"
import style0 from "./DragDropTable.vue?vue&type=style&index=0&id=7f0f0c76&lang=scss&scoped=true&"
import style1 from "./DragDropTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f0c76",
  null
  
)

export default component.exports